module.exports = __webpack_public_path__ + "img/consultation1.03d48070.png";